import { CrudServiceBase } from './CrudServiceBase';
import { InfractionRuleDto } from '@/models/infractions/InfractionRuleDto';
import { InfractionTypeDto } from '@/models/infractions/InfractionTypeDto';
import { InfractionRuleTypeDto } from '@/models/infractions/InfractionRuleTypeDto';
import { RequestResult, HttpMethodEnum } from '@questelservices/common';
export class InfractionRuleService extends CrudServiceBase<InfractionRuleDto> {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  async getRuleTypes(): Promise<InfractionRuleTypeDto[]> {
    return await this.client.get('/ruletypes');
  }

  async getTypes(): Promise<InfractionTypeDto[]> {
    return await this.client.get<InfractionTypeDto[]>('/infractiontypes')
      .then(result => result.sort((a, b) => a.Name.localeCompare(b.Name)));
  }

  async addNewInfraction(newInfraction: InfractionTypeDto): Promise<RequestResult> {
    return await this.client.postJson('/newInfraction', newInfraction);
  }
}
